export class LocalStorageHelper {
  static setProject(projectId: string, expiresAt: string, productCategory: string) {
    localStorage.setItem('projectId', projectId);
    localStorage.setItem('expiresAt', expiresAt);
    localStorage.setItem('category', productCategory.toLowerCase());
  }

  static clearProject() {
    localStorage.removeItem('projectId');
    localStorage.removeItem('expiresAt');
    localStorage.removeItem('category');
    localStorage.removeItem('lastPage');
    localStorage.removeItem('psfUrl');
    localStorage.removeItem('mediaclipIsSaved');
  }

  static setDevice(device: string) {
    localStorage.setItem('device', device);
  }
  static getDevice() {
    return localStorage.getItem('device');
  }

  static setLastPage(lastPage: string) {
    localStorage.setItem('lastPage', lastPage);
  }
  static getLastPage() {
    return localStorage.getItem('lastPage');
  }

  static setPsfUrl(psfUrl: string) {
    localStorage.setItem('psfUrl', psfUrl);
  }
  static getPsfUrl() {
    return localStorage.getItem('psfUrl');
  }

  static setProjectId(projectId: string) {
    localStorage.setItem('projectId', projectId);
  }
  static getProjectId() {
    return localStorage.getItem('projectId');
  }

  static setExpiresAt(expiresAt: string) {
    localStorage.setItem('expiresAt', expiresAt);
  }
  static getExpiresAt() {
    return localStorage.getItem('expiresAt');
  }

  static setCategory(category: string) {
    localStorage.setItem('category', category);
  }
  static getCategory() {
    return localStorage.getItem('category');
  }

  static setMediaclipIsSaved(mediaclipIsSaved: string) {
    localStorage.setItem('mediaclipIsSaved', mediaclipIsSaved);
  }
  static getMediaclipIsSaved() {
    return localStorage.getItem('mediaclipIsSaved');
  }
}
